import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ScheduleListService = {
    garrisonSchedule: async () => axios.get(`${API_URL}/schedulesList/garrisonSchedule`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default ScheduleListService;